import { useState } from 'react';

const API_URL = process.env.REACT_APP_API_URL || '';

export default function Login({ onLogin }) {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const pw = password.trim();
    if (!pw) return;

    setLoading(true);
    setError('');
    try {
      const res = await fetch(`${API_URL}/admin/physical-mail/calendar?month=2000-01`, {
        headers: { Authorization: `Bearer ${pw}` },
      });
      if (res.status === 401) {
        setError('비밀번호가 올바르지 않습니다.');
        setLoading(false);
        return;
      }
      onLogin(pw);
    } catch {
      setError('서버에 연결할 수 없습니다.');
    }
    setLoading(false);
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <h2>나중편지 관리자</h2>
        <form onSubmit={handleSubmit}>
          <input
            type="password"
            placeholder="관리자 비밀번호"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <button type="submit" disabled={loading}>{loading ? '확인 중...' : '로그인'}</button>
          {error && <p style={{ color: '#dc2626', fontSize: 13, marginTop: 8 }}>{error}</p>}
        </form>
      </div>
    </div>
  );
}
